/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusAccountItem
 */
export interface BonusAccountItem {
    /**
     * 账户ID
     * @type {number}
     * @memberof BonusAccountItem
     */
    id?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof BonusAccountItem
     */
    userId?: number;
    /**
     * 会员名
     * @type {string}
     * @memberof BonusAccountItem
     */
    userName?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof BonusAccountItem
     */
    userCode?: string;
    /**
     * 当前余额（净额模型，同user_wallet.amount：不含冻结金额，即可用余额）
     * @type {number}
     * @memberof BonusAccountItem
     */
    balance?: number;
    /**
     * 冻结金额（待确认支付单占用，冻结时已从余额转出）
     * @type {number}
     * @memberof BonusAccountItem
     */
    freezeAmount?: number;
    /**
     * 可用额度（=balance，净额模型下余额本身即可用；保留字段便于前端直取）
     * @type {number}
     * @memberof BonusAccountItem
     */
    availableAmount?: number;
    /**
     * 待发放金额（进行中计划的待发放批次合计）
     * @type {number}
     * @memberof BonusAccountItem
     */
    pendingGrantAmount?: number;
    /**
     * 累计已发放（Σ流水type=1）
     * @type {number}
     * @memberof BonusAccountItem
     */
    totalGrantedAmount?: number;
    /**
     * 已使用（Σ流水type=2）
     * @type {number}
     * @memberof BonusAccountItem
     */
    usedAmount?: number;
    /**
     * 可用账单类型集合（billType数组，空=全部不可用）
     * @type {Array<number>}
     * @memberof BonusAccountItem
     */
    availableBillTypes?: Array<number>;
    /**
     * 是否显示赠送金流水画面 0 隐藏，1 显示
     * @type {number}
     * @memberof BonusAccountItem
     */
    showCompensationMenu?: number;
    /**
     * 账户创建时间
     * @type {string}
     * @memberof BonusAccountItem
     */
    createTime?: string;
}

/**
 * Check if a given object implements the BonusAccountItem interface.
 */
export function instanceOfBonusAccountItem(value: object): value is BonusAccountItem {
    return true;
}

export function BonusAccountItemFromJSON(json: any): BonusAccountItem {
    return BonusAccountItemFromJSONTyped(json, false);
}

export function BonusAccountItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusAccountItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'balance': json['balance'] == null ? undefined : json['balance'],
        'freezeAmount': json['freezeAmount'] == null ? undefined : json['freezeAmount'],
        'availableAmount': json['availableAmount'] == null ? undefined : json['availableAmount'],
        'pendingGrantAmount': json['pendingGrantAmount'] == null ? undefined : json['pendingGrantAmount'],
        'totalGrantedAmount': json['totalGrantedAmount'] == null ? undefined : json['totalGrantedAmount'],
        'usedAmount': json['usedAmount'] == null ? undefined : json['usedAmount'],
        'availableBillTypes': json['availableBillTypes'] == null ? undefined : json['availableBillTypes'],
        'showCompensationMenu': json['showCompensationMenu'] == null ? undefined : json['showCompensationMenu'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function BonusAccountItemToJSON(json: any): BonusAccountItem {
    return BonusAccountItemToJSONTyped(json, false);
}

export function BonusAccountItemToJSONTyped(value?: BonusAccountItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'balance': value['balance'],
        'freezeAmount': value['freezeAmount'],
        'availableAmount': value['availableAmount'],
        'pendingGrantAmount': value['pendingGrantAmount'],
        'totalGrantedAmount': value['totalGrantedAmount'],
        'usedAmount': value['usedAmount'],
        'availableBillTypes': value['availableBillTypes'],
        'showCompensationMenu': value['showCompensationMenu'],
        'createTime': value['createTime'],
    };
}

